// import React, { useEffect, useState } from 'react';
// import siteQueries from '../../queries/siteQueries';
// import { BASE_URL } from '../../apis/api';
// import { useNavigate } from 'react-router-dom';
// import RouteConstants from '../../constant/Routeconstant';

// function Sidebar() {
//   const [speakers, setSpeakers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const speakerMutation = siteQueries.useFeaturedspeakerListingMutation((data) => {
//     // Extract speakers from the nested data structure and limit to 4
//     setSpeakers(data?.data?.slice(0, 4) || []);
//     setLoading(false);
//   });

//   useEffect(() => {
//     setLoading(true);
//     speakerMutation.mutate();
//   }, []);

//   const handleSpeakersList = () => {
//     navigate(RouteConstants.SPEAKERLISTSITEILFK)
//   }

//   return (
//     <div className="w-full flex flex-col gap-4">
//       <div className="bg-white p-4 rounded-lg shadow">
//         {/* Header */}
//         <h4 className="font-semibold mb-3 text-gray-800">Featured Speakers</h4>
        
//         {loading ? (
//           <div className="flex justify-center py-4">
//             <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
//           </div>
//         ) : speakers.length > 0 ? (
//           <div>
//             {/* Speakers grid - flex layout on small screens, vertical on larger screens */}
//             <div className="flex gap-2 sm:space-y-3 sm:flex-col">
//               {speakers.map((item, index) => (
//                 <div key={item.id || index} className="flex items-center gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors sm:flex-row flex-col">
//                   {/* Speaker Image */}
//                   <div className="flex-shrink-0">
//                     <img
//                       src={`${BASE_URL}/${item.speaker?.photo}`}
//                       alt={item.speaker?.heading || 'Speaker'}
//                       className="w-12 h-12 rounded-full object-cover border-2 border-gray-200"
//                       onError={(e) => {
//                         e.target.src = '/default-avatar.png';
//                       }}
//                     />
//                   </div>
                  
//                   {/* Speaker Info - Hidden on small screens */}
//                   <div className="flex-1 min-w-0 hidden sm:block">
//                     <h5 className="font-medium text-sm text-gray-900 truncate">
//                       {item.speaker?.heading || 'Unknown Speaker'}
//                     </h5>
//                     {/* Uncomment if you want to show additional info
//                     <p className="text-xs text-gray-600 truncate">
//                       {item.speaker?.contact_person || 'Speaker'}
//                     </p>
//                     {item.speaker?.email && (
//                       <p className="text-xs text-blue-600 truncate mt-1">
//                         {item.speaker.email}
//                       </p>
//                     )} */}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ) : (
//           <p className="text-gray-500 text-sm py-2 hidden sm:block">No speakers available</p>
//         )}
        
//         {/* View All Link - Always show at bottom */}
//         {speakers.length >= 4 && (
//           <div className="mt-3 pt-3 border-t border-gray-200">
//             <button 
//               onClick={handleSpeakersList}
//               className="text-blue-600 hover:text-blue-800 text-xs font-medium transition-colors"
//             >
//               View All Speakers →
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Sidebar;
import React, { useEffect, useState } from 'react';
import siteQueries from '../../queries/siteQueries';
import { BASE_URL } from '../../apis/api';
import { useNavigate } from 'react-router-dom';
import RouteConstants from '../../constant/Routeconstant';

function Sidebar() {
  const [speakers, setSpeakers] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const speakerMutation = siteQueries.useFeaturedspeakerListingMutation((data) => {
    setSpeakers(data?.data?.slice(0, 5) || []);
    setLoading(false);
  });

  useEffect(() => {
    setLoading(true);
    speakerMutation.mutate();
  }, []);

  const handleSpeakersList = () => {
    navigate(RouteConstants.SPEAKERLISTSITEILFK)
  }

  return (
    <div className="flex flex-col gap-1 bg-yellow-200 p-1 rounded-lg">
      {/* Header */}
      <h4 className="font-semibold text-gray-800 text-left mb-2">Speakers</h4>

      {loading ? (
        <div className="flex justify-center py-4">
          <div className="animate-spin rounded-full h-6 border-b-2 border-blue-500"></div>
        </div>
      ) : speakers.length > 0 ? (
        <div className="flex flex-col gap-3">
          {speakers.map((item, index) => (
            <div
              key={item.id || index}
              className="flex flex-col items-center text-center gap-1 bg-transparent p-3 rounded-md shadow-sm hover:bg-gray-50 transition-colors"
            >
              {/* Speaker Image */}
              <img
                src={`${BASE_URL}/${item.speaker?.photo}`}
                alt={item.speaker?.heading || 'Speaker'}
                className="w-14 h-14 rounded-full object-cover border-2 border-gray-200"
                
              />
              {/* Speaker Heading Below Image */}
              <h5 className="font-medium text-sm text-gray-900 mt-1">
                {item.speaker?.heading || 'Unknown Speaker'}
              </h5>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500 text-sm py-2 text-center">No speakers available</p>
      )}

      {/* View All Link */}
      {speakers.length >= 4 && (
        <div className="mt-3 pt-3 border-t border-gray-200 text-center">
          <button 
            onClick={handleSpeakersList}
            className="text-blue-600 hover:text-blue-800 text-xs font-medium transition-colors"
          >
            View All Speakers →
          </button>
        </div>
      )}
    </div>
  );
}

export default Sidebar;
